import { render, staticRenderFns } from "./middle-ellipsis-text.vue?vue&type=template&id=55e2bf17&scoped=true&"
import script from "./middle-ellipsis-text.vue?vue&type=script&lang=js&"
export * from "./middle-ellipsis-text.vue?vue&type=script&lang=js&"
import style0 from "./middle-ellipsis-text.vue?vue&type=style&index=0&id=55e2bf17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e2bf17",
  null
  
)

export default component.exports